import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { ReactComponent as Logo } from '../../../assets/icons/brand/logo_64.svg';
import { useLayout } from '../../../context/LayoutContext';
import { useWindowSize } from '../../../hooks/use-window-size';
import { AgreementType } from '../../../redux/api/agreements/interfaces';
import AgreementsModal, {
  AgreementsModalMode,
} from '../../reusable/agreements/AgreementsModal';
import Footer from '../footer/Footer';
import Header from '../header/Header';
import Menu from '../menu/Menu';
import { useStyles } from './LayoutContainer.styles';

interface PageContainerProps {
  children: React.ReactNode;
}

const LayoutContainer = (props: PageContainerProps) => {
  const { children } = props;
  const { mobileView } = useWindowSize();
  const { isMenuOpen, showMenu, hideMenu } = useLayout();
  const theme = useTheme();
  const [menuPolicyModalType, setMenuPolicyModalType] =
    useState<AgreementType | null>(null);

  const { classes } = useStyles(theme);
  const { t } = useTranslation();

  return (
    <main className={classes.pageWrapper}>
      <Header>
        <Box className={classes.headerWrapper}>
          <Box className={classes.logoContainer}>
            <Logo />
            <Typography variant="h2">{t('common.companyName')}</Typography>
          </Box>
        </Box>
      </Header>
      <Box className={classes.pageContainerWrapper}>
        {(isMenuOpen || !mobileView) && (
          <Menu
            setShowMenu={(value: boolean) => (value ? showMenu() : hideMenu())}
            onOpenPolicyModal={(agreementType) =>
              setMenuPolicyModalType(agreementType)
            }
          />
        )}
        {menuPolicyModalType != null && (
          <AgreementsModal
            open
            mode={AgreementsModalMode.VIEW}
            agreementType={menuPolicyModalType}
            onClose={() => setMenuPolicyModalType(null)}
          />
        )}
        {children}
      </Box>
      <Footer
        setShowMenu={(value: boolean) => (value ? showMenu() : hideMenu())}
      />
    </main>
  );
};

export default LayoutContainer;
